"use client";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import PricingOfferButton from "~/app/[locale]/pricing/components/PricingOfferButton";

import styles from "./ActionButtonSection.module.scss";

export default function ActionButtonSection({ locale, slug }) {
  const { t } = useTranslation(locale);


  return (
    <section className={styles.section} aria-labelledby="pseo-cta-title">
      <div className="wrap">
        <div className={styles.content}>
          <div className={styles.copy}>
            <h2 id="pseo-cta-title" className={styles.title}>
              {t(/** @i18n */ "solutions.prompt.cta.title")}
            </h2>
            <p className={styles.desc}>
              {t(/** @i18n */ "solutions.prompt.cta.subtitle")}
            </p>
          </div>
          <div className={styles.buttonWrapper}>
            <PricingOfferButton className={clsx("pill", styles.ctaButton)} source={`solutions-${slug}`} />
          </div>
        </div>
      </div>
    </section>
  );
}
